import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const helpLinks = [
  { to: '/comics', label: '漫画大全' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-magic-line text-xl"></i>
              </span>
              <span className="font-heading text-xl text-primary-500">麻瓜漫画</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              原版漫画在线阅读平台，收录完整版、未删减原版与导演剪辑版漫画，覆盖多种热门题材，每日更新最新章节，畅快追更不折腾。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-qq-line', 'ri-weibo-line', 'ri-douban-line'].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* categories */}
          <nav aria-label="分类导航">
            <h4 className="text-sm font-bold text-foreground-950">热门分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2">
              {categories.slice(0, 8).map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/comics?category=${c.id}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* quick links */}
          <nav aria-label="快速导航">
            <h4 className="text-sm font-bold text-foreground-950">快捷导航</h4>
            <ul className="mt-4 flex flex-col gap-2">
              {helpLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                  常见问题
                </a>
              </li>
            </ul>
          </nav>

          {/* contact */}
          <div>
            <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                hello@mugua-manhua.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                客服：周一至周日 9:00 - 22:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                每日上午 10:00 批量更新
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            © 2026 麻瓜漫画网 · 原版漫画在线阅读平台 · 保留所有权利
          </p>
          <p className="text-xs text-foreground-500">本站资源仅用于学习交流，请支持正版。</p>
        </div>
      </div>
    </footer>
  );
}